<template>
  <div class="XzqhLxfs">
    <div class="headerSearch">
      <div class="sousuo">
        <el-form
          ref="search"
          style="width: calc(100% - 225px)"
          :model="formInline"
          label-position="left"
          label-width="90px"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="行政区划:">
                <el-select v-model="formInline.xzqhId" filterable placeholder="请选择">
                  <el-option
                    v-for="item in xzqhList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="width:225px">
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            size="small"
            @click="handleCurrentChange(1)"
          >搜索</el-button>
          <el-button
            icon="el-icon-refresh-left"
            round
            size="small"
            @click="resetDataSource"
          >重置</el-button>
        </div>

      </div>
    </div>
    <div
      style="margin: auto;
        width: 95%;
        max-width: 1518px;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;"
    >
      <div class="tablemes">
        <div
          style="
            background-color: #f2f2f2;
            padding: 10px;
            border: 1px solid #f2f2f2;
          "
        >
          <el-button
            v-preventReClick
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="addLoad()"
          >新增</el-button>
        </div>
        <el-table
          ref="gmzHqfxTabel"
          :data="tableData"
          border
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
        >
          <el-table-column
            prop="xzqhLabel"
            label="行政区划"
          />
          <el-table-column
            prop="lxdh"
            label="联系电话"
          />
          <el-table-column
            prop="zxfwUrl"
            label="在线服务网址"
          />
          <el-table-column label="操作" align="center" width="200px">
            <template slot-scope="scope">
              <el-button
                v-preventReClick
                type="primary"
                icon="el-icon-document"
                size="mini"
                @click="updLoad(scope.row)"
              >修改</el-button>
              <el-button
                v-preventReClick
                type="danger"
                icon="el-icon-document"
                size="mini"
                @click="removeSave(scope.row.xzqhId)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev,pager,next,jumper,total,sizes"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
    <el-dialog title="维护行政区划联系方式" :visible.sync="updFlag">
      <el-form :model="saveFrom" label-width="150px">
        <el-form-item label="行政区划">
          <el-select
            v-model="saveFrom.xzqhId"
            filterable
            placeholder="请选择"
            style="width: 100%"
            :disabled="updId != ''"
          >
            <el-option
              v-for="item in xzqhList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式:">
          <el-input
            v-model="saveFrom.lxdh"
          />
        </el-form-item>
        <el-form-item label="在线服务网址:">
          <el-input
            v-model="saveFrom.zxfwUrl"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updFlag = false">取 消</el-button>
        <el-button type="primary" @click="dataSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getXZQHList } from '@/assets/js/xzqh'
import { lxfsList, addLxzfsSave, editLxzfsSave, removeLxzfsSave } from '@/assets/js/xzqhLxfs'

export default {
  name: 'XzqhLxfs',
  data() {
    return {
      updId: '', // 编辑时的数据主键
      updFlag: false,
      formInline: { // 搜索表单
        xzqhId: ''
      },
      saveFrom: {
        xzqhId: '',
        lxdh: '',
        zxfwUrl: ''
      },
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0, // 列表总数
      tableData: [], // 表格数据
      xzqhList: []
    }
  },
  mounted() {
    getXZQHList({
      param: {}
    }).then(res => {
      if (res.status === 200 && res.data.code === '000000') {
        this.xzqhList = []
        const sj = res.data.data
        sj.forEach((elem, index) => {
          const obj = { label: elem.areaName, value: elem.xzqhId }
          this.xzqhList.push(obj)
        })
      }
    })
    this.loadDatasource()
  },
  methods: {
    // 查询列表数据
    loadDatasource() {
      lxfsList({
        page: this.currentPage,
        size: this.pagesize,
        param: this.formInline
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadDatasource()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.loadDatasource()
    },
    // 重置
    resetDataSource() {
      this.formInline = {
        xzqhId: ''
      },
      this.loadDatasource()
    },
    addLoad() {
      this.updId = ''
      this.saveFrom = {
        xzqhId: '',
        lxdh: '',
        zxfwUrl: ''
      }
      this.updFlag = true
    },
    // 打开编辑
    updLoad(row) {
      this.updFlag = true
      this.updId = row.xzqhId
      this.saveFrom = { ...row }
    },
    // 新增or修改
    dataSave() {
      this.$confirm('确定是否保存数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        if (this.updId == '') {
          addLxzfsSave(this.saveFrom).then(() => {
            this.$message.success('提交成功!')
            this.updFlag = false
            this.loadDatasource()
          })
        } else {
          editLxzfsSave(this.saveFrom).then(() => {
            this.$message.success('提交成功!')
            this.updFlag = false
            this.loadDatasource()
          })
        }
      })
      //
    },
    // 删除
    removeSave(xzqhId) {
      this.$confirm('确定是否删除数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        removeLxzfsSave(xzqhId).then(() => {
          this.$message.success('删除成功!')
          this.loadDatasource()
        })
      })
    }
  }
}
</script>

<style scoped lang='less'>
  .XzqhLxfs {
    .headerSearch {
      max-width: 1518px;
      width: 95%;
      margin: auto;
      margin-bottom: 11px;
      margin-top: 30px;
      background-color: white;
      padding: 30px 0 20px 0;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .sousuo {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: space-between;
      }
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
      }
    }
    .tablemes {
      margin: auto;
      width: 90%;
      max-width: 1375px;
      // margin-top: 21px;
      // margin-bottom: 57px;
      // /deep/ .el-table__header {
      //   .el-checkbox {
      //     display: none !important;
      //   }
      // }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      // .addButton {
      //   color: #fff;
      //   background: #4170ff;
      //   border-radius: 3px;
      //   border-color: #4170ff;
      // }
      .deleteButton {
        background: #ff5721 !important;
        border-color: #ff5721 !important;
      }
      .el-button--warning {
        color: #fff;
        background: #feb800;
        border-radius: 3px;
        border-color: #feb800;
      }
      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  /deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none !important;
  }
</style>
